module.exports = __webpack_public_path__ + "img/brand-mosru.95086f26.svg";